export type Lang = "fr" | "en";

export const translations = {
  fr: {
    appName: "Rockfall",
    appSuffix: "Operations Center",
    nav: {
      section_pilotage: "Pilotage",
      section_ventes: "Ventes",
      section_logistique: "Logistique",
      section_administration: "Administration",
      preview: "Résolution documentaire",
      dashboard: "Tableau de bord",
      clients: "Clients",
      produits: "Produits",
      commandes: "Commandes",
      inventaire: "Inventaire",
      achats: "Achats",
      expedition: "Préparation / Expédition",
      facturation: "Facturation",
      livraisons: "Preuves de livraison",
      statistiques: "Statistiques",
      utilisateurs: "Utilisateurs",
    },
    header: {
      search: "Rechercher une commande, un client, un produit…",
      theme: "Thème",
      lang: "Langue",
      backendOnline: "Backend connecté",
      backendOffline: "Backend injoignable",
      backendChecking: "Vérification…",
      operator: "Opérateur",
      menu: "Menu",
    },
    common: {
      loading: "Chargement des données…",
      error: "Impossible de charger les données",
      errorHint:
        "Le backend FastAPI existant n'a pas répondu. Vérifiez que l'API est démarrée et accessible.",
      retry: "Réessayer",
      empty: "Aucune donnée disponible",
      emptyHint: "Aucun enregistrement ne correspond aux critères actuels.",
      cancel: "Annuler",
      confirm: "Confirmer",
      close: "Fermer",
      search: "Rechercher",
      filters: "Filtres",
      allStatuses: "Tous les statuts",
      reset: "Réinitialiser",
      mock: "MOCK",
      phase: "Phase 1",
    },
    dashboard: {
      title: "Tableau de bord",
      subtitle: "Vue d'ensemble des opérations Rockfall",
      kpiNote:
         "Données opérationnelles provenant de GET /dashboard/resume — aucun calcul KPI n'est effectué dans le frontend.",
      alertes: "Alertes opérationnelles",
      alertesSource: "Source : GET /dashboard/alertes",
      commandesOuvertes: "Commandes ouvertes",
      commandesSource: "Source : GET /dashboard/commandes-ouvertes",
      kpi: {
        po_recus_aujourdhui: "PO reçus aujourd'hui",
        commandes_ouvertes: "Commandes ouvertes",
        commandes_a_verifier: "Commandes à vérifier",
        commandes_a_acheter: "Commandes à acheter",
        commandes_a_preparer: "Commandes à préparer",
        expediees_a_facturer: "Expédiées à facturer",
        factures_a_envoyer: "Factures à associer Sage",
        produits_stock_faible: "Produits en stock faible",
        valeur_commandes_ouvertes: "Valeur commandes ouvertes",
        valeur_attente_fournisseur: "Valeur en attente fournisseur",
      },
      table: {
        numero: "N° commande",
        client: "Client",
        statut: "Statut",
        dateRequise: "Date de réception",
        lignes: "Lignes",
        montant: "Montant",
      },
    },
    placeholder: {
      plannedFor: "Développement prévu",
      backendReady: "Endpoints backend existants",
      noBackend: "Endpoint backend supplémentaire requis",
      notice:
        "Fondation Phase 1 : la structure visuelle est en place, le module métier sera branché sur le backend FastAPI existant.",
      capabilities: "Contenu prévu du module",
    },
    modules: {
      clients: {
        title: "Clients",
        subtitle: "Gestion des clients Rockfall",
        body: "Le module Clients sera développé à la Phase 2.",
      },
      produits: {
        title: "Produits",
        subtitle: "Catalogue et données produits",
        body: "Le catalogue Produits sera développé dans une phase ultérieure.",
      },
      commandes: {
        title: "Commandes",
        subtitle: "Cycle de vie des commandes clients",
        body: "Le workflow complet Commandes sera développé dans une phase ultérieure.",
      },
      inventaire: {
        title: "Inventaire",
        subtitle: "Stock, réservations et disponibilité",
        body: "Les opérations d'inventaire restent exécutées par le backend et seront branchées plus tard.",
      },
      achats: {
        title: "Achats",
        subtitle: "Approvisionnement et fournisseurs",
        body: "Le workflow Achats sera développé dans une phase ultérieure.",
      },
      expedition: {
        title: "Préparation / Expédition",
        subtitle: "Préparation entrepôt et expéditions",
        body: "La préparation entrepôt et l'expédition seront développées dans une phase ultérieure.",
      },
      facturation: {
        title: "Facturation",
        subtitle: "Facturation et suivi des paiements",
        body: "La facturation complète sera développée dans une phase ultérieure.",
      },
      statistiques: {
        title: "Statistiques",
        subtitle: "Indicateurs et analyses opérationnelles",
        body: "Les statistiques seront développées dans une phase ultérieure.",
      },
      utilisateurs: {
        title: "Utilisateurs",
        subtitle: "Comptes, rôles et permissions",
        body: "L'authentification, les rôles et les permissions ne sont pas inclus dans la Phase 1.",
      },
    },
    notFound: {
      title: "Page introuvable",
      body: "Cette route ne fait pas partie de Rockfall Operations Center.",
      back: "Retour au tableau de bord",
    },
  },
  en: {
    appName: "Rockfall",
    appSuffix: "Operations Center",
    nav: {
      section_pilotage: "Overview",
      section_ventes: "Sales",
      section_logistique: "Logistics",
      section_administration: "Administration",
      preview: "Document resolution",
      dashboard: "Dashboard",
      clients: "Customers",
      produits: "Products",
      commandes: "Orders",
      inventaire: "Inventory",
      achats: "Purchasing",
      expedition: "Picking / Shipping",
      facturation: "Invoicing",
      livraisons: "Delivery proofs",
      statistiques: "Statistics",
      utilisateurs: "Users",
    },
    header: {
      search: "Search an order, customer or product…",
      theme: "Theme",
      lang: "Language",
      backendOnline: "Backend connected",
      backendOffline: "Backend unreachable",
      backendChecking: "Checking…",
      operator: "Operator",
      menu: "Menu",
    },
    common: {
      loading: "Loading data…",
      error: "Unable to load data",
      errorHint:
        "The existing FastAPI backend did not respond. Make sure the API is running and reachable.",
      retry: "Retry",
      empty: "No data available",
      emptyHint: "No records match the current criteria.",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      search: "Search",
      filters: "Filters",
      allStatuses: "All statuses",
      reset: "Reset",
      mock: "MOCK",
      phase: "Phase 1",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "Rockfall operations overview",
      kpiNote:
        "Temporary values. On integration they will come from GET /dashboard/resume — no KPI is computed in the frontend.",
      alertes: "Operational alerts",
      alertesSource: "Planned source: GET /dashboard/alertes",
      commandesOuvertes: "Open orders",
      commandesSource: "Planned source: GET /dashboard/commandes-ouvertes",
      kpi: {
        po_recus_aujourdhui: "POs received today",
        commandes_ouvertes: "Open orders",
        commandes_a_verifier: "Orders to verify",
        commandes_a_acheter: "Orders to purchase",
        commandes_a_preparer: "Orders to pick",
        expediees_a_facturer: "Shipped, to invoice",
        factures_a_envoyer: "Invoices awaiting Sage",
        produits_stock_faible: "Low stock products",
        valeur_commandes_ouvertes: "Open orders value",
        valeur_attente_fournisseur: "Value awaiting supplier",
      },
      table: {
        numero: "Order no.",
        client: "Customer",
        statut: "Status",
        dateRequise: "Required date",
        lignes: "Lines",
        montant: "Amount",
      },
    },
    placeholder: {
      plannedFor: "Planned development",
      backendReady: "Existing backend endpoints",
      noBackend: "Additional backend endpoint required",
      notice:
        "Phase 1 foundation: the visual structure is in place, the business module will be wired to the existing FastAPI backend.",
      capabilities: "Planned module content",
    },
    modules: {
      clients: {
        title: "Customers",
        subtitle: "Rockfall customer management",
        body: "The Customers module will be developed in Phase 2.",
      },
      produits: {
        title: "Products",
        subtitle: "Catalogue and product data",
        body: "The Products catalogue will be developed in a later phase.",
      },
      commandes: {
        title: "Orders",
        subtitle: "Customer order lifecycle",
        body: "The full Orders workflow will be developed in a later phase.",
      },
      inventaire: {
        title: "Inventory",
        subtitle: "Stock, reservations and availability",
        body: "Inventory operations stay in the backend and will be wired later.",
      },
      achats: {
        title: "Purchasing",
        subtitle: "Procurement and suppliers",
        body: "The Purchasing workflow will be developed in a later phase.",
      },
      expedition: {
        title: "Picking / Shipping",
        subtitle: "Warehouse picking and shipping",
        body: "Warehouse picking and shipping will be developed in a later phase.",
      },
      facturation: {
        title: "Invoicing",
        subtitle: "Invoicing and payment follow-up",
        body: "Full invoicing will be developed in a later phase.",
      },
      statistiques: {
        title: "Statistics",
        subtitle: "Operational indicators and analysis",
        body: "Statistics will be developed in a later phase.",
      },
      utilisateurs: {
        title: "Users",
        subtitle: "Accounts, roles and permissions",
        body: "Authentication, roles and permissions are out of scope for Phase 1.",
      },
    },
    notFound: {
      title: "Page not found",
      body: "This route is not part of Rockfall Operations Center.",
      back: "Back to dashboard",
    },
  },
} as const;

export type Dictionary = typeof translations.fr;
